<script setup lang="ts">
import { NSteps } from 'naive-ui'
import { useAttrs } from 'vue'

const props = withDefaults(defineProps<{
  current?: number
  status?: 'process' | 'finish' | 'error' | 'wait'
  size?: 'small' | 'medium'
  vertical?: boolean
  placement?: 'horizontal' | 'vertical'
  onUpdateCurrent?: (current: number) => void
}>(), {
  current: 0,
  status: 'process',
  size: 'medium',
  vertical: false,
  placement: 'horizontal',
})

const emit = defineEmits<{
  'update:current': [current: number]
}>()

const attrs = useAttrs()

const onUpdateCurrent = (current: number) => {
  emit('update:current', current)
}
</script>

<template>
  <NSteps
    :current="current"
    :status="status"
    :size="size"
    :vertical="vertical"
    :placement="placement"
    v-bind="attrs"
    @update:current="onUpdateCurrent"
  >
    <slot />
  </NSteps>
</template>

<style scoped>
/* Custom styles can be added here if needed */
</style>
